import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const HouseHoldHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="house_hold" t={t}>
      <Box mb={3}>
        <H3>Personen im Haushalt</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>Die Angabe der Personenanzahl ist für eine sorgfältige Prüfung unerlässlich.</Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Wurde im Mietvertrag eine Umlage der Nebenkosten nach Personen pro Haushalt vereinbart, muss der Vermieter
          theoretisch
          <b>taggenau</b>
          den Verbrauch auf Grundlage der jeweiligen Personenanzahl dokumentieren. Da dies in der Praxis kaum möglich
          ist, werden die Bewohnerzahlen in größeren Abständen (z.B. monatlich) festgehalten, solange hier keine
          größeren Schwankungen vorliegen.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Die Kostenverteilung nach Personen lässt
          <b>keine Rückschlüsse auf das tatsächliche Verbrauchsverhalten</b>
          der Personen zu, so kann beispielsweise eine Person so viel Verbrauch haben wie eine sparsame Kleinfamilie.
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle margined>
          Beispiele für Kostenpositionen, die häufig nach Personen pro Haushalt berechnet werden, sind die Wasser-,
          Abwasser- und Müllkosten. Rechnet der Vermieter hier mit einer falschen Personenanzahl, kann dies eine
          <b>ungerechtfertigt hohe Zahlung</b>
          für den Mieter nach sich ziehen.
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle>
          Wichtig ist auch der Vergleich mit dem Durchschnittsverbrauch: Liegt Ihr Verbrauch mit der jeweiligen
          Personenanzahl im regionalen Durchschnitt? Verbraucht Ihr Haushalt eventuell mehr?
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default HouseHoldHelp;
